'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _dashboard = require('./dashboard.component');

var _dashboard2 = _interopRequireDefault(_dashboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dashboardModule = _angular2.default.module('dashboard', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('dashboard', {
    url: '/main',
    component: 'dashboard'
  });
}).component('dashboard', _dashboard2.default).name;

exports.default = dashboardModule;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/dashboard.js